import StickyBottom from '@/components/StickyBottom';
import styles from './index.less';
import { useState } from 'react';
import { history, Helmet, useModel } from '@umijs/max';
import OperationList from '@/components/OperationList';
// import { Toast } from 'react-vant';
import MaskDialog from '@/components/MaskDialog';
import payFeeUrl from '@/assets/home/image 162@2x.png';
import parkingFeeUrl from '@/assets/home/image 161@2x.png';
import topUpFeeUrl from '@/assets/home/image 163@2x.png';
import warrantyUrl from '@/assets/home/image 164@2x.png';
import guideUrl from '@/assets/home/image 165@2x.png';
import announcementUrl from '@/assets/home/image 166@2x.png';
// import moreUrl from '@/assets/home/image 167@2x.png';
import homeUrl from '@/assets/home/image168.png';
import houseUrl from '@/assets/serves/p3.png';
import workUrl from '@/assets/serves/p1.png';
import lageUrl from '@/assets/serves/p4.png';
import propertyUrl from '@/assets/serves/p6.png';
import phoneyUrl from '@/assets/serves/p2.png';
import speUrl from '@/assets/serves/p7.png';
import { Toast } from 'react-vant';

export type OperationListListType = {
  label: string;
  icon: string;
  redirectUrl: string;
};

const Services = () => {
  const [maskDialogVisible, setMaskDialogVisible] = useState<boolean>(false);
 
  const { bindInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      bindInformation: model.bindInformation,
    }),
  );

  const checkBindRoom = () => {
    return (
      bindInformation?.car === '0' &&
      bindInformation?.room === '0' &&
      bindInformation?.park === '0'
    );
  };

  const openMaskDialog = () => {
    setMaskDialogVisible(true);
  };

  const handleQuickClick = (value: string) => {
    if (value !== '') {
      if ((value.indexOf('wechatActivity') === -1 && value.indexOf('wechatNews') === -1) && checkBindRoom()) {
        Toast('请您先绑定房屋！');
        return;
      } else {
        history.push(value);
      }
    } else {
      openMaskDialog();
    }
  };

  const quickOperationList: OperationListListType[] = [
    { label: '生活缴费', icon: payFeeUrl, redirectUrl: '/account/bill' },
  ];

  const lifeList: OperationListListType[] = [
    { label: '社区资讯', icon: parkingFeeUrl, redirectUrl: '/wechatNews' },
    { label: '公告公示', icon: topUpFeeUrl, redirectUrl: '/announcement' },
    { label: '报事报修', icon: warrantyUrl, redirectUrl: '' }, ///repairManage
    { label: '社区活动', icon: homeUrl, redirectUrl: '/wechatActivity' },
    { label: '问卷调查', icon: guideUrl, redirectUrl: '/questionnaire' },
    { label: '投票', icon: announcementUrl, redirectUrl: '/vote' },
  ];
  const helpList: OperationListListType[] = [
    { label: '房屋租售', icon: houseUrl, redirectUrl: '/houseRentAndSale' },
    { label: '办事指南', icon: workUrl, redirectUrl: '/workGuide' },
    { label: '我要留言', icon: lageUrl, redirectUrl: '/leaveMessage' },
    { label: '关于物业', icon: speUrl, redirectUrl: '/aboutProperty' },
    { label: '专属管家', icon: propertyUrl, redirectUrl: '/bult' },
    { label: '常用电话', icon: phoneyUrl, redirectUrl: '/phone' },
  ];

  return (
    <div className={styles.container}>
      <Helmet>
        <title>服务</title>
      </Helmet>
      <OperationList
        quickClick={handleQuickClick}
        title="缴费"
        list={quickOperationList}
      />
      <OperationList
        quickClick={handleQuickClick}
        title="生活服务"
        list={lifeList}
      />
      <OperationList
        quickClick={handleQuickClick}
        title="便民服务"
        list={helpList}
      />
      <MaskDialog visible={maskDialogVisible} close={setMaskDialogVisible} />
      <StickyBottom activeKey={'services'} />
    </div>
  );
};

export default Services;
